import React, { usedata, useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
// import AnalysisLeadDialog from "./AnalysisLeadDialog";
// import { data } from "../../../App";
import { Tooltip } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { GridList, GridListTile } from "@material-ui/core";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import Grid from '@mui/material/Grid';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import moment from 'moment'
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



function createData(
  leadId,
  distance,
  fseName,
  fseNumber,
  shopName,
  merchantName,
  upi_id,
  store_front_image,
  qc_status,
  agency_id,
  created_on
) {
  return {
    leadId,
    distance,
    fseName,
    fseNumber,
    shopName,
    merchantName,
    upi_id,
    store_front_image,
    qc_status,
    agency_id,
    created_on
  };
}


const useStyles = makeStyles({
  table: {
    minWidth: 500,
  },

});

export default function CustomizedTables(data) {
  console.log('data', data)
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('md');
  const [leadDetail, setLeadDetail] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [data, setdata] = usedata(data);
  const [rows, setRows] = useState([]);
  const [selectedTile, setSelectedTile] = React.useState(null);
  const [value, setValue] = React.useState([]);
  const [activeStep, setActiveStep] = React.useState(0);


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const handleClickOpen = item => {
    setSelectedTile(item);
    console.log("clicked");
    console.log(item);
  };

  const handleClose1 = () => {
    setSelectedTile(null);
  };
  useEffect(() => {
    if (data.data && data.data.merchant_name_info) {
      const rows1 = [
        ...data.data.merchant_name_info.map(
          ({
            main_lead_id,
            distance,
            fse_name,
            fse_number,
            shop_name,
            merchant_name,
            upi_id,
            store_front_image,
            qc_status,
            agency_id,
            created_on
          }) => {
            return createData(
              main_lead_id,
              distance,
              fse_name,
              fse_number,
              shop_name,
              merchant_name,
              upi_id,
              store_front_image,
              qc_status,
              agency_id,
              created_on
            );
          }
        ),
      ];
      setRows([...rows1]);
    }
  }, [data.data]);

  const handleClick = (event, value) => {
    setAnchorEl(event.currentTarget);
    setLeadDetail(value)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open1 = Boolean(anchorEl);
  const id = open1 ? 'simple-popover' : undefined;
  return (
    <>
      <div style={{ padding: 10 }}>
        <GridList cols={6}>
          className={classes.gridList}
          {rows && rows.map(item => (
            <GridListTile key={item.store_front_image} >
              <img src={item.store_front_image} alt={item.store_front_image} onClick={() => handleClickOpen(item)} />
              <GridListTileBar style={{height:'30px', top: 0,left:" 55%", background: item.qc_status == "1" ? '#8db055' : item.qc_status == "2" ? "rgb(214 218 62)" : item.qc_status == "3" ? "#c2595d" : item.qc_status == "0" ? '#abaca5' : '' }}
                title={<b style={{ fontSize: 12 }}>{item.distance.toFixed(2)}M</b>}
                // subtitle={`${item.distance.toFixed(2)} in Meter`}
                actionIcon={
                  <IconButton
                    aria-label={`info about ${item.title}`}
                    className={classes.icon}
                    value={item.id}
                    onClick={(e) => handleClick(e, item)}
                  >
                    <InfoIcon />
                  </IconButton>
                }


              />
            </GridListTile>
          ))}
        </GridList>

        <Popover
          id={id}
          open={open1}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Typography style={{ padding: 10 }}>{`Lead ID : ${leadDetail && leadDetail.leadId}`}<br />
            {`Shop Name : ${leadDetail && leadDetail.shopName}`}<br />
            {`Merchant Name : ${leadDetail && leadDetail.merchantName}`}<br />
            {`FSE Name : ${leadDetail && leadDetail.fseName}`}<br />
            {`FSE No : ${leadDetail && leadDetail.fseNumber}`}<br />
            {`UPI ID : ${leadDetail && leadDetail.upi_id}`}<br />
            {`Agency ID : ${leadDetail && leadDetail.agency_id}`}<br />
            {`Lead Status : ${leadDetail && leadDetail.qc_status == "1" ? "Approved (Green)" : ""}
                     ${leadDetail && leadDetail.qc_status == "0" ? "Pending" : ""}
                     ${leadDetail && leadDetail.qc_status == "3" ? "Rejected (Red)" : ""}
                     ${leadDetail && leadDetail.qc_status == "2" ? "Partially Approved (Yellow)" : ""}`}<br /></Typography>
        </Popover>
        <Dialog
          // fullScreen
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={selectedTile !== null}
          onClose={handleClose1}
          TransitionComponent={Transition}
        >

          <Grid xs={12} container >
            <Grid xs={8} item>
              {selectedTile && (
                <img src={selectedTile.store_front_image} alt={selectedTile.store_front_image} style={{ width: '100%' }} />
              )}
            </Grid>
            <Grid xs={4} item>
              <h4 style={{ padding: 15, textAlign: 'center', background: 'rgb(149 152 154)' ,margin:0}}>Lead Detail</h4>
              <Typography sx={{ p: 2 }} style={{ fontSize: 14 }}> <b>Lead ID :</b>{` ${selectedTile && selectedTile.leadId}`}<br />
                <b>Shop Name :</b>  {`${selectedTile && selectedTile.shopName}`}<br />
                <b>Merchant Name :</b>{` ${selectedTile && selectedTile.merchantName}`}<br />
                <b>FSE Name : </b>{` ${selectedTile && selectedTile.fseName}`}<br />
                <b>FSE No :</b>  {` ${selectedTile && selectedTile.fseNumber}`}<br />
                <b>UPI ID :</b> {` ${selectedTile && selectedTile.upi_id}`}<br />
                <b>Agency ID : </b> {` ${selectedTile && selectedTile.agency_id}`}<br />
                <b>Created On : </b> {` ${selectedTile && moment(selectedTile.created_on).format("DD-MM-YYYY") + ' ' + moment(selectedTile.created_on, 'DD-MM-YYYY hh:mm').format("HH:mm:ss a")}`}<br />
                <b>Lead Status : </b> {` ${selectedTile && selectedTile.qc_status == "1" ? "Approved (Green)" : ""}
                     ${selectedTile && selectedTile.qc_status == "0" ? "Pending" : ""}
                     ${selectedTile && selectedTile.qc_status == "3" ? "Rejected (Red)" : ""}
                     ${selectedTile && selectedTile.qc_status == "2" ? "Partially Approved (Yellow)" : ""}`}<br /></Typography>
            </Grid>
          </Grid>
        </Dialog>
      </div>

    </>
  );
}
